import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-101">
    <HashRouter data-id="element-102">
      <App data-id="element-103" />
    </HashRouter>
  </React.StrictMode>);